export default "__VITE_ASSET__DDTeHyV4__"